import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course04 from "../../../course/course-04/course";
import lesson0419 from "../../../lesson/course-04/lesson-19/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "7bc9b280-43dc-4956-aa7e-4da08f3b95af",
    course: {
      id: course04.id,
      slug: course04.slug as string,
      name: course04.name,
      publicId: course04.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course04, lesson0419),
    lesson: lesson0419,
  },
];

export default lessonLinks;
